<script>
export default {
  name: 'TabPanel',
  props: {
    name: {
      required: true,
    },
    label: {
      required: true,
    },
  },
  computed: {
    isActive() {
      return this.$parent.value === this.name;
    },
  },
  render(h) {
    return h(
      'div',
      {
        class: {
          Tab__Panel: true,
        },
        style: {
          ...(!this.isActive
            ? {
                display: 'none',
              }
            : {}),
        },
      },
      this.$slots.default
    );
  },
  methods: {},
};
</script>
